/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Status_AuthorizedInputs */

const en_inbound_status_authorized = /** @type {(inputs: Inbound_Status_AuthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorized, packing list to type`)
};

/**
* | output |
* | --- |
* | "Authorized, packing list to type" |
*
* @param {Inbound_Status_AuthorizedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_status_authorized = /** @type {((inputs?: Inbound_Status_AuthorizedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Status_AuthorizedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_status_authorized(inputs)
});